// extracted by mini-css-extract-plugin
export default {"title":"lower_title__GNFXt","info":"lower_info__AX3jx","button":"lower_button__zat4s","heading":"lower_heading__p-JKf"};